import apolloClient from '../apolloClient';
import { GET_CAMPAIGN_MESSAGES } from './queries/campaignMessages';
import { SEND_CAMPAIGN_MESSAGE, MARK_MESSAGES_AS_READ } from './mutations/campaignMessages';

/**
 * Fetch campaign messages
 */
export const fetchCampaignMessagesGraphQL = async (campaignId) => {
  try {
    const { data } = await apolloClient.query({
      query: GET_CAMPAIGN_MESSAGES,
      variables: { campaignId: parseInt(campaignId, 10) },
      fetchPolicy: 'network-only' // Always fetch fresh messages
    });

    return data.campaignMessages || [];
  } catch (error) {
    console.error('Error fetching campaign messages:', error);
    throw error;
  }
};

/**
 * Send a campaign message with optional attachment
 */
export const sendCampaignMessageGraphQL = async (campaignId, message, attachmentUrl = null) => {
  try {
    // Customer portal chat supports attachment-only messages.
    // Normalize text so backend receives null when user sends only an image/file.
    const normalizedMessage = typeof message === 'string' ? message.trim() : '';

    const { data } = await apolloClient.mutate({
      mutation: SEND_CAMPAIGN_MESSAGE,
      variables: {
        input: {
          campaignId: parseInt(campaignId, 10),
          message: normalizedMessage || null,
          attachmentUrl
        }
      }
    });

    return data.sendCampaignMessage;
  } catch (error) {
    console.error('Error sending campaign message:', error);
    throw error;
  }
};

/**
 * Mark messages as read
 */
export const markMessagesAsReadGraphQL = async (messageIds) => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: MARK_MESSAGES_AS_READ,
      variables: {
        messageIds: messageIds.map(id => parseInt(id, 10))
      }
    });

    return data.markCampaignMessagesAsRead;
  } catch (error) {
    console.error('Error marking messages as read:', error);
    throw error;
  }
};
